import React from 'react'
import { Typography, Tooltip, Button, Tag, Switch, List } from 'antd'
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import { PlusCircleOutlined } from '@ant-design/icons'
import moment from 'moment';
import { IsStormvloed } from '@utils';
import { sortByDate, sortByString } from '../../../utils/functions/Sorters';

const { Text } = Typography;

export default function skillColumns(
    appState,
    allRaces, 
    allSkills,
    onRowClick
) {
   
    const columns = [
        {
            title: 'Name',
            key: 'name',
            render: (record) => {
                return (<Text>{record.name}</Text>)
              },
              sorter: (a, b) => sortByString(a.name, b.name),
              sortDirections: ['ascend', 'descend', 'ascend'],
              filters: setSkillTypeFilters(appState),
              filterMode: 'tree',
              onFilter: (value, record) => value.test(record.name)

        },
        {
            title: 'Description',
            key: 'description',
            render: (record) => {
               return (<TextEditorReadOnly content={record.description}/>)
             },
        },
        getSkillPointCostColumn(appState),
        getRequiresColumn(allRaces, allSkills, appState),
        {
          title: 'Last updated',
          dataIndex: 'lastUpdated',
          key: 'lastUpdated',
          render: (date) => {
             return (<Text>
               {moment(date).format('DD-MM-YYYY HH:mm')}
             </Text>)
           },
           sorter: (a, b) => sortByDate(a.lastUpdated, b.lastUpdated),
           sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: 'Action',
            key: 'action', 
            render: (record) => {

            return(<Button onClick={() => onRowClick(record)}>View</Button>) 
            }
        }
    ]
    return columns;
}


//record, isSkillRecord, allRaces, allSkills
export function skillsList(  
  list,
  appState,
  onRowClick,
  allRaces,
  allSkills
  
) {
  return list.map(_ => {
    return (
            <List.Item
              style={{display:"flex", flexDirection:"column"}}
              // extra={[
              //   <Tag>{getSkillPointCostColumnOnRender(_)}</Tag>,
              // ]}
              onClick={() => onRowClick(_)}
            >

              <List.Item.Meta
                style={{width:"100%"}}
                title={_.name}
                description={<TextEditorReadOnly content={_.description}/>}
              />
              <div className="list-tags">
                {getRequiresRender(_, false, allRaces, allSkills, appState)}
                <Tag>{getSkillPointCostColumnOnRender(_, appState)}</Tag>
              </div>
            </List.Item>
    )
  })
}


export function characterSkillListItems(

  skills,
  onRowClick,
  appState,
  newCharacter,
  onRemoveClick
) {

  if(!skills) {
    return []
  }
    return skills.map(_ => {

      var found = findRequiredSkill(skills, _, appState, newCharacter)
      return (
              <List.Item
                actions={[
                found !== undefined ?
                    <Tooltip title={`You have another skill that possibly requires this skill (${found.skill?.name})`}>
                        <Button disabled="true" onClick={() => onRemoveClick(_)}>Remove</Button>
                    </Tooltip> :
                    <Button onClick={() => onRemoveClick(_)}>Remove</Button>
                    
                ]}
              >
                <List.Item.Meta
                  title={<Button type="text" onClick={() => onRowClick(_)}>{_.skill.name}</Button>}
                  description={<TextEditorReadOnly content={_.skill.description}/>}
                />
              </List.Item>
      )
    })
}

export function characterSkillColumns(
    appState,
    allRaces, 
    allSkills,
    onRemoveClick,
    onRowClick,
    newCharacter
) {
    
    const columns = [
        {
            title: 'Name',
            key: 'name',
            render: (record) => {
                return (<Text>{record.skill.name}</Text>)
              },
              sorter: (a, b) => sortByString(a.skill?.name, b.skill?.name),
              sortDirections: ['ascend', 'descend', 'ascend'],
              filters: setSkillTypeFilters(appState),
              filterMode: 'tree',
              onFilter: (value, record) => value.test(record.skill.name)
        },
        {
            title: 'Description',
            key: 'description',
            render: (record) => {
               return (<TextEditorReadOnly content={record.skill.description}/>)
             },
        },
        getSkillPointCostColumn(appState, true),
        getRequiresColumn(allRaces, allSkills,appState, true),
        {
            title: 'Action',
            key: 'action', 
            render: (record) => {

                let found = findRequiredSkill(allSkills, record, appState, newCharacter);

              return(
                  <>
                  {found !== undefined ?
                    <Tooltip title={`You have another skill that possibly requires this skill (${found.skill?.name})`}>
                        {/* <span>Please make sure you only have 1 main character</span> */}
                        <Button disabled="true" onClick={() => onRemoveClick(record)}>Remove</Button>
                    </Tooltip> :
                    <Button onClick={() => onRemoveClick(record)}>Remove</Button>
                    }


 
                    <Button onClick={() => onRowClick(record)}>View</Button> 
                  </> 
            )
            }
          }
    ]
    return columns;
}

function findRequiredSkill(allSkills, record, appState, newCharacter) {
  let found = allSkills.find(_ => _.skill.requiredSkills.find(req => req.requiredSkillId === record.skill.id)
  );

  if (found === undefined) {
    found = allSkills.find(_ => _.skill.andRequiredSkills.find(req => req.requiredSkillId === record.skill.id)
    );
  }

  if (found === undefined && record.skill.increaseStats.length > 0) {
    record.skill.increaseStats.forEach(increaseStat => {
      found = allSkills.find(_ => _.skill.requiredStats.find(stat => stat.statTypeId === increaseStat.statTypeId && CheckStat(stat, increaseStat)));

    });
  }

  function CheckStat(stat, increaseStat) {
    switch (stat.statType.name) {
      case appState.statTypeNames.hp:
        return newCharacter.hp - increaseStat.amount < stat.amount;
      case appState.statTypeNames.strength:
        return newCharacter.strength - increaseStat.amount < stat.amount;
      case appState.statTypeNames.mana:
        return newCharacter.mana - increaseStat.amount < stat.amount;
      case appState.statTypeNames.stamina:
        return newCharacter.stamina - increaseStat.amount < stat.amount;
        case appState.statTypeNames.rp:
          return newCharacter.rp - increaseStat.amount < stat.amount;
      default:
        break;
    }
    return false;
  }
  return found;
}

export function skillsToChoseList(  
  list,
  appState,
  onAddClick,
  onRowClick,
  
) {
  return list.map(_ => {
    return (
            <List.Item
              extra={[
                <Tag>{getSkillPointCostColumnOnRender(_, appState)}</Tag>
              ]}
            >
              <List.Item.Meta
                avatar={<Button type="primary" shape="circle" onClick={() => onAddClick(_)} icon={<PlusCircleOutlined />}/>}
                title={_.name}
                description={
                  <>
                  <TextEditorReadOnly content={_.description}/>
                  <Button onClick={() => onRowClick(_)}>View</Button>
                  </>}
              />
                
            </List.Item>
    )
  })
}

export function skillsToChoseColumns(
  appState,
  onAddClick,
  onRowClick
) {

  const columns = [
    {
      title: 'Action',
      key: 'action', 
      render: (record) => {
        return(
            <>
              <Button type="primary" shape="circle" onClick={() => onAddClick(record)} icon={<PlusCircleOutlined />}/>
               <Button onClick={() => onRowClick(record)}>View</Button> 
            </> 
      )
      }
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => sortByString(a.name, b.name),
        sortDirections: ['ascend', 'descend', 'ascend'],
        filters: setSkillTypeFilters(appState),
        filterMode: 'tree',
        onFilter: (value, record) => value.test(record.name)
    },
    getSkillPointCostColumn(appState),
    {
        title: 'Description',
        key: 'description',
        dataIndex: 'description',
        render: (description) => {
           return (<TextEditorReadOnly content={description}/>)
         },
    }
  ]

  return columns;
}

export function adminSkillColumns(
  appState,
  allSkills,
  onRowClick
) {
  
    const columns = [
      {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) => sortByString(a.name, b.name),
          sortDirections: ['ascend', 'descend', 'ascend'],
          filters: setSkillTypeFilters(appState),
          filterMode: 'tree',
          onFilter: (value, record) => value.test(record.name)
      },
      {
        title: 'Can be chosen',
        dataIndex: 'canBeChosen',
        key: 'CanBeChosen',
        render: (CanBeChosen) => {
          return (
            <Switch checked={CanBeChosen} disabled/>
          )
        }
      },
      {
          title: 'Type',
          dataIndex: 'skillPointType',
          key: 'skillPointType',
          hidden: !IsStormvloed(appState.storyName),
          render: (skillPointType) => {
            return (<Text>
              {skillPointType.name}
            </Text>)
          },
          filters: setSkillpointFilters(appState),
          onFilter: (value, record) => record.skillPointType?.id === value, 
      },
      getRequiresColumn(undefined, allSkills, appState),
      {
        title: 'Last updated',
        dataIndex: 'lastUpdated',
        key: 'lastUpdated',
        render: (date) => {
          return (<Text>
            {moment(date).format('DD-MM-YYYY HH:mm')}
          </Text>)
        },
        sorter: (a, b) => sortByDate(a.lastUpdated, b.lastUpdated),
        sortDirections: ['ascend', 'descend', 'ascend'],
      },
      {
        title: 'Action',
        key: 'action', 
        render: (record) => {

        return(<Button onClick={() => onRowClick(record)}>View</Button>) 
        }
    }
  ].filter(_ => !_.hidden)

  return columns;
}

function getSkillPointCostColumnOnRender(record, appState) {

    if(IsStormvloed(appState.storyName)) {
      return record.pointCost === 0 ? `Free` :`${record.pointCost}x ${record.skillPointType.name}`
    }

    return record.pointCost;
}

function getSkillPointCostColumn(appState, isSkillRecord) {

    return {
      title: 'Skillpoint cost',
      key: 'skillPointType',
      render: (record) => {
        return <Text>
        {getSkillPointCostColumnOnRender(isSkillRecord ? record.skill : record, appState)}
        </Text>
      },
      filters: setSkillpointFilters(appState),
      onFilter: (value, record) => {
        if (isSkillRecord) {
          return record.skill?.skillPointType?.id === value
        }
        return record.skillPointType?.id === value}, 
      sorter: (a, b) => isSkillRecord? a.skill?.pointCost - b.skill?.pointCost : a.pointCost - b.pointCost,
      sortDirections: ['ascend', 'descend', 'ascend'],
  }
}

function getRequiresRender(record, isSkillRecord, allRaces, allSkills, appState) {
  const requiredStats = record.requiredStats;
  const requiredRaces = [];
  const requiredSkills = [];
  const requiredAndSkills = [];
  const requiredMutual = []

  if(record.requiredRaces !== undefined) {
      record.requiredRaces.forEach(required => {

        if(allRaces !== undefined) {
          const found = allRaces.find(race => race.id === required.raceId);
          if(found !== undefined) {
            requiredRaces.push(found)  
          }
          return;
        }
        
        requiredRaces.push(required.race)

      }) 
  }

  if(record.requiredSkills !== undefined) {
      record.requiredSkills.forEach(required => {

        if(isSkillRecord === true) {
          const foundSkill = allSkills?.find(_ => _.skill.id === required.requiredSkillId)
          if(foundSkill !== undefined) {
            requiredSkills.push(foundSkill.skill)  
          }
          return 
        }
        
        const foundSkill = allSkills?.find(_ => _.id === required.requiredSkillId)
        if(foundSkill !== undefined) {
          requiredSkills.push(foundSkill)  
        }
      }) 
  }

  if(record.andRequiredSkills !== undefined) {
    record.andRequiredSkills.forEach(required => {

      if(isSkillRecord === true) {
        const foundSkill = allSkills?.find(_ => _.skill.id === required.requiredSkillId)
        if(foundSkill !== undefined) {
          requiredAndSkills.push(foundSkill.skill)  
        }
        return 
      }
      
      const foundSkill = allSkills?.find(_ => _.id === required.requiredSkillId)
      if(foundSkill !== undefined) {
        requiredAndSkills.push(foundSkill)  
      }
    }) 
}

if(record.mutualExclusiveSkills !== undefined && record.mutualExclusiveSkills !== null) {
  record.mutualExclusiveSkills.forEach(required => {
    if(isSkillRecord === true) {
      const foundSkill = allSkills?.find(_ => _.skill.id === required.id)
      if(foundSkill !== undefined) {
        requiredMutual.push(foundSkill.skill)  
      }
      return 
    }

    const foundSkill = allSkills?.find(_ => _.id === required.id)
    if(foundSkill !== undefined) {
      requiredMutual.push(foundSkill)  
    }
  }) 
}

  const requiredStatTags = requiredStats.map(_ => 
    <Tooltip key={_} title="(Stat requirement) All of the red tags are required to get this skill">
      <Tag  color="red">{_.statType.name} {_.amount}</Tag>
    </Tooltip>
  )
  const requiredRacesTags = requiredRaces.map(_ => 
    <Tooltip key={_} title={`(${IsStormvloed(appState.storyName) ? "Race" : "World"} requirement) At least one of the blue tags is required to get this skill`}>
      <Tag color="blue">{_.name}</Tag>
    </Tooltip>
  )
  const requiredSkillsTags = requiredSkills.map(_ => 
    <Tooltip key={_} title="(Skill requirement) At least one of the purple tag is required to get this skill">
      <Tag color="purple">{_.name}</Tag>
    </Tooltip>
  )
  const requiredAndSkillsTags = requiredAndSkills.map(_ => 
    <Tooltip key={_} title="(Skill requirement) All of the orange tags are required to get this skill">
      <Tag color="orange">{_.name}</Tag>
    </Tooltip>
  )

  const requiredMutualTags = requiredMutual.map(_ => 
    <Tooltip key={_} title="(Skill requirement) All of the yellow tags are skills that you can't have in combination with this skill">
      <Tag color="yellow">(not) {_.name}</Tag>
    </Tooltip>
  )

  return (
    <>
      {requiredStatTags}
      {requiredRacesTags}
      {requiredSkillsTags}
      {requiredAndSkillsTags}
      {requiredMutualTags}
    </>
  )
}

function getRequiresColumn(allRaces, allSkills, appState, isSkillRecord) {
    return {
      title: 'Requires',
      key: 'requires',
      render: (record) => {
        return getRequiresRender(isSkillRecord === true ? record.skill : record, isSkillRecord, allRaces, allSkills, appState)
    }
  }
}

function setSkillpointFilters(appState) {
  if (IsStormvloed(appState.storyName)) {
    
    return [
      // {
      //   text: "Algemeen",
      //   value: 1
      // },
      {
        text: "Strijd",
        value: 2
      },
      {
        text: "Ambacht",
        value: 3
      },
    ];
  }
}

function setSkillTypeFilters(appState) {
  if (IsStormvloed(appState.storyName)) {
    
    return [
      {
        text: "Spreuken",
        value: /^Magisch [eE]ffect/
      },
      {
        text: "Skills",
        value: /^(?!Magisch [eE]ffect)/
      }
    ];
  }
  return [
    {
      text: "Skills",
      value: /^[ACDEHOPRU]\d\d/,
      children: [
        {
          text: "Alchemist",
          value: /^A\d\d/
        },
        {
          text: "Crafting",
          value: /^C\d\d/
        },
        {
          text: "Divine Ritualist",
          value: /^D\d\d/
        },
        {
          text: "Endurance",
          value: /^E\d\d/
        },
        {
          text: "Healing",
          value: /^H\d\d/
        },
        {
          text: "Outlander",
          value: /^O\d\d/
        },
        {
          text: "Protection",
          value: /^P\d\d/
        },
        {
          text: "Runecaster",
          value: /^R\d\d/
        },
        {
          text: "Utilities",
          value: /^U\d\d/
        },
      ],
    },
    {
      text: "Spells",
      value: /^Spreuk/
    },
    {
      text: "World Skills",
      value: /(Abasga)|(Thalassië)|(Rorrum)|(Cybele-68)|(Pannotia)|(Carmyrris)/
    },
  ];
}